import { Heart, ShoppingBag, Star } from "lucide-react";
import { Link } from "react-router-dom";

export default function ProductCard({
  id,
  image,
  category,
  name,
  price,
  rating,
  badge,
}) {
  return (
    <article className="group">

      <Link to={`/product/${id}`}>

        <div className="relative overflow-hidden rounded-3xl bg-[#F7F8F4]">

          <img
            src={image}
            alt={name}
            className="h-96 w-full object-cover duration-700 group-hover:scale-110"
          />

          {/* Badge */}

          <span className="absolute left-5 top-5 rounded-full bg-[#6B8E5F] px-4 py-2 text-xs font-medium text-white">
            {badge}
          </span>

          {/* Hover Buttons */}

          <div className="absolute right-5 top-5 flex flex-col gap-3 opacity-0 transition-all duration-300 group-hover:opacity-100">

            <button className="rounded-full bg-white p-3 shadow-lg">
              <Heart size={18}/>
            </button>

            <button className="rounded-full bg-[#6B8E5F] p-3 text-white shadow-lg">
              <ShoppingBag size={18}/>
            </button>

          </div>

        </div>

      </Link>

      <div className="mt-5">

        <p className="text-sm uppercase tracking-[2px] text-[#6B8E5F]">
          {category}
        </p>

        <h3 className="mt-2 text-xl font-semibold">
          {name}
        </h3>

        <div className="mt-3 flex items-center gap-2">

          <Star
            size={16}
            fill="#FBBF24"
            color="#FBBF24"
          />

          <span>{rating}</span>

        </div>

        <div className="mt-4 flex items-center justify-between">

          <p className="text-xl font-bold">
            ${price}
          </p>

          <button className="rounded-full bg-[#6B8E5F] px-5 py-2 text-sm text-white transition hover:bg-[#557149]">
            Add
          </button>

        </div>

      </div>

    </article>
  );
}
// import { Heart, ShoppingBag } from "lucide-react";
// import { Link } from "react-router-dom";

// export default function ProductCard({
//   id,
//   image,
//   category,
//   name,
//   price,
// }) {
//   return (
//     <div className="group">

//       <Link to={`/product/${id}`}>

//         <div className="relative overflow-hidden rounded-3xl bg-[#F5F5F0]">

//           <img
//             src={image}
//             alt={name}
//             className="h-80 w-full object-cover transition duration-700 group-hover:scale-110"
//           />

//           {/* Hover Icons */}

//           <div className="absolute top-5 right-5 flex flex-col gap-3 opacity-0 transition duration-300 group-hover:opacity-100">

//             <button className="rounded-full bg-white p-3 shadow">

//               <Heart size={18} />

//             </button>

//             <button className="rounded-full bg-[#6B8E5F] p-3 text-white shadow">

//               <ShoppingBag size={18} />

//             </button>

//           </div>

//         </div>

//       </Link>

//       <div className="mt-5">

//         <p className="text-sm uppercase tracking-wider text-[#6B8E5F]">
//           {category}
//         </p>

//         <h3 className="mt-2 text-xl font-medium text-[#1F2937]">
//           {name}
//         </h3>

//         <p className="mt-2 text-lg font-semibold">
//           ${price}
//         </p>

//       </div>

//     </div>
//   );
// }